<template>
  <v-dialog v-model="show" persistent width="360">
    <v-card>
      <v-card-title class="headline"> Forgot your password? </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            If you forgot your password or your password reset token expired, we can send a password reset
            link to your email.
          </v-row>
          <v-row class="mt-6">
            <v-text-field
              v-model="lcUsername"
              :rules="[rules.required]"
              name="username"
              label="Email"
              v-on:keyup.enter="confirm"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-alert v-if="alert.show" dense outlined :type="alert.type">
              {{ alert.message }}
            </v-alert>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('update:show', false)">
          Close
        </v-btn>
        <v-btn color="primary" text @click="resetPassword()">
          Send email
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "ForgotPasswordModal",
  props: ["show", "username"],
  data() {
    return {
      rules: {
        required: (value) => !!value || "Required.",
      },
      alert: {
        show: false,
        type: 'success',
        message: ''
      },
    };
  },
  methods: {
    resetPassword() {
      this.$store
        .dispatch("dispatchForgotPassword", { identifier: this.username })
        .then(() => {
          this.alert.show = true;
          this.alert.type = 'success';
          this.alert.message = 'Password reset email sent, please check you inbox.';
        }).catch(() => {
          this.alert.show = true;
          this.alert.type = 'error';
          this.alert.message = 'User with this email does not exist.';
        });
    },
  },
  computed: {
    lcUsername: {
      get(){
        return this.username;
      },
      set(value){
        this.username = value.toLowerCase()
      }
    }
  }
};
</script>